import React from 'react';

const Plus = () => {
  return (
    <svg className="cursor-pointer" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.6409 9.8959H9.49904V14.8408C9.49904 15.637 8.8279 16.2824 8 16.2824C7.1721 16.2824 6.50096 15.637 6.50096 14.8408V9.8959H1.35909C0.586845 9.81899 0 9.19317 0 8.44653C0 7.6999 0.586845 7.07407 1.35909 6.99717H6.48484V2.06777C6.56481 1.32511 7.21557 0.760742 7.99194 0.760742C8.76832 0.760742 9.41907 1.32511 9.49904 2.06777V6.99717H14.6409C15.4132 7.07407 16 7.6999 16 8.44653C16 9.19317 15.4132 9.81899 14.6409 9.8959V9.8959Z" fill="#0075FA"/>
    </svg>
  );
};

export default Plus;
